<template>
    <div class="h-full w-full">
        <apex-charts
            :width="width"
            :height="height"
            :options="options"
            :series="series"
            :class="className"
            @legendClick="legendClick"
            @markerClick="markerClick" />
    </div>
</template>
<script setup lang="ts">
import ApexCharts from './apexchart.vue'
const { $formatters } = useNuxtApp()

const props = defineProps({
  labels: {
    type: Array,
    default: () => []
  },
  series: {
    type: Array,
    default: () => [
      {
        name: 'test',
        data: []
      }
    ]
  },
  value: [String, Number],
  type: {
    type: String,
    default: 'bar'
  },
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '100%'
  },
  foreColor: {
    type: String,
    default: '#333'
  },
  fillColor: {
    type: String,
    default: '#333'
  },
  bgColor: String,
  className: String
})
const { type, labels, series, foreColor, fillColor, bgColor } = toRefs(props)

const options = computed(() => {
  switch (type.value) {
  case 'pie':
  case 'donut':
    return {
      chart: {
        type: type.value,
        foreColor: foreColor.value,
        toolbar: {
          show: false
        }
      },
      tooltip: {
        theme: false,
        style: {
          fontSize: '12px',
          fontFamily: undefined
        }
      },
      legend: {
        position: 'bottom'
      },
      responsive: [
        {
          breakpoint: 480,
          chart: {
            width: 200
          },
          options: {
            legend: {
              position: 'bottom'
            }
          }
        }
      ],
      labels: labels.value
    }
  case 'line':
  case 'bar':
    return {
      chart: {
        type: type.value,
        width: 380,
        foreColor: foreColor.value,
        toolbar: {
          show: false
        }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        colors: fillColor.value,
        pattern: {
          style: 'verticalLines',
          width: 2,
          height: 2,
          strokeWidth: 2
        }
      },
      markers: {
        size: 6,
        colors: foreColor.value,
        strokeColors: bgColor?.value || foreColor.value,
        strokeOpacity: 0.8
      },
      stroke: {
        curve: 'straight',
        lineCap: 'round',
        colors: fillColor.value,
        width: 3
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          borderRadiusApplication: 'end',
          columnWidth: '40%'
        }
      },
      grid: {
        show: true,
        borderColor: '#F1F1F1',
        strokeDashArray: 5,
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        },
        row: {
          opacity: 0.5
        },
        column: {
          opacity: 0.5
        }
      },
      tooltip: {
        theme: false,
        style: {
          fontSize: '12px',
          fontFamily: undefined
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ],
      yaxis: {
        labels: {
          formatter: function (value: number) {
            if (typeof value === 'number') {
              return $formatters.formatNumber(value)
            }
            return value
          }
        }
      },
      labels: labels.value
    }
  default:
    return {
      labels: labels.value
    }
  }
})

const legendClick = (value: any) => {
  console.log('legendClick', value)
}

const markerClick = (value: any) => {
  console.log('markerClick', value)
}
</script>
